<div id="popupHover" class="ol-popupHover">
	<div id="popup-contentHover"></div>
</div>
<div id="popupClusterHover" class="ol-cluster-popupHover ">
	<div id="popup-ClustercontentHover"></div>
</div>
<div id="etiquetas"></div>
<div class="map-content" id="map-content">
	<div class="content-botones" *ngIf="estadoHistorico"  id="botonesRecorrido">
		<button (click)="abrirHistorico();" style="cursor: pointer;" class="btn btn-historico"><i
				class="fal fa-calendar-alt"></i> Histórico</button>
		<button *ngIf="videosDisponibles"  (click)="abrirVideos();" class="btn btn-azulMarino"><i class="fal fa-video"></i>
			Video</button>
		<button *ngIf="videosDisponibles" (click)="abrirGraficaVelocidad();" class="btn btn-azulMarino"><i class="fal fa-analytics"></i>
			Velocidad</button>
		<button (click)="obtenerCoordenadaPixel();" class="btn btn-azulMarino"><i class="fas fa-map-pin"></i>
			Punto</button>
		<button (click)="imprimirRecorrido();" class="btn btn-azulMarino"><i class="fas fa-file-pdf"></i>
			Imprimir</button>
		<button (click)="irInicioRecorrido();" class="btn btn-primary"><i class="fal fa-flag-checkered"></i>
			Inicio</button>
		<button (click)="irAnterior();" class="btn btn-azulMarino"><i class="fal fa-backward"></i> Anterior</button>
		<button (click)="irSiguiente();" class="btn btn-azulMarino"><i class="fal fa-forward"></i>
			Siguiente</button>
		<button (click)="irFinalRecorrido();" class="btn btn-azul"><i class="fal fa-map-marker"></i> Final</button>
		<button (click)="cerrarRecorrido();" class="btn btn-gris"><i class="fal fa-times"
				style="margin-left: 5px;"></i></button>
	</div>
	<div id="map" class="map"></div>
</div>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" message="Cargando...">
</dx-load-panel>
